export interface BannerConfiguration {
  centerContent?: boolean;
  displayNameProp?: string;
  image: string;
  isFullWidthImage?: boolean;
  subtitle?: string;
  title: string;
}
